import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import SecondaryBtn from '@/shared/components/ui/SecondaryBtn/SecondaryBtn';
import PrimaryButton from 'shared/components/ui/PrimaryButton/PrimaryButton';
import { ROUTES } from 'shared/constants';
import { WinnerStatusEnum } from 'shared/constants/shared-enums';

import ControllerIcon from 'assets/controller-brown.svg?react';
import defeatIcon from 'assets/png/defeat-icon.png';
import victoryIcon from 'assets/png/victory-icon.png';
import ShareIcon from 'assets/share.svg?react';

interface NewFinishViewProps {
  isWinner: boolean;
  showModal?: boolean;
  onShareClick?: () => void;
  winnerStatus?: WinnerStatusEnum;
}
export const NewFinishView = ({
  isWinner,
  showModal,
  onShareClick,
  winnerStatus,
}: NewFinishViewProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="w-full flex flex-col justify-center items-center">
      <img
        src={isWinner ? victoryIcon : defeatIcon}
        alt=""
        className={`w-[65%] hd:mt-10 ${isWinner ? 'max-w-[550px]' : 'max-w-[330px]'}`}
      />
      {isWinner ? (
        <div
          className="text-[#ffffff] text-center text-[72px] leading-[72px] mb-9 font-black relative"
          style={{
            WebkitTextStroke: '2px #fbd551',
          }}
        >
          <span className="z-0">VICTORY</span>
          <div
            className="rounded-[50%]  absolute top-0 bottom-0 left-0 right-0 z-10"
            style={{
              background:
                'radial-gradient(closest-side at center, rgba(238, 175, 10, 0.25) 0%, rgba(238, 175, 10, 0) 100%)',
            }}
          ></div>
        </div>
      ) : (
        <div
          className="text-[#ffffff] text-center text-[72px] leading-[72px] mb-9 font-black relative"
          style={{
            WebkitTextStroke: '2px #e81c34',
          }}
        >
          <span className="z-0">DEFEAT</span>
          <div
            className="rounded-[50%]  absolute top-0 bottom-0 left-0 right-0 z-10"
            style={{
              background:
                'radial-gradient(closest-side at center, rgba(232, 28, 52, 0.25) 0%,   rgba(232, 28, 52, 0) 100%',
            }}
          ></div>
        </div>
      )}
      {showModal && (
        <div className="w-[86%] max-w-[550px] bg-violet rounded-[20px] border-solid border-border border p-5 flex flex-col gap-4 xlg:gap-8 items-start justify-start relative">
          <div className="flex flex-col gap-4 items-start justify-start self-stretch shrink-0 relative">
            <div className="text-white text-left  text-2xl leading-8 font-semibold relative self-stretch">
              {isWinner ? t('finishView.winTitle') : t('finishView.loseTitle')}
            </div>
            <div className="text-white text-left  text-base  font-normal relative self-stretch">
              {isWinner ? t('finishView.winText') : t('finishView.loseText')}
            </div>
          </div>
          <div className="flex w-full gap-4 items-center justify-between mt-4">
            <PrimaryButton
              onClick={() => {
                navigate(ROUTES.LOBBY);
              }}
              svg={<ControllerIcon className="w-5 h-5 sm:w-6 sm:h-6" />}
              text={t('finishView.playAgain')}
              className="w-full"
            />
            {winnerStatus === WinnerStatusEnum.WinnerPlayerA ||
            winnerStatus === WinnerStatusEnum.WinnerPlayerB ? (
              <SecondaryBtn
                onClick={onShareClick}
                svg={<ShareIcon />}
                className="h-full"
                childClassName="h-full flex items-center"
              />
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};
